import { useMutation, useQueryClient } from "@tanstack/react-query"

import { ContentService, type TopicMergeRequest } from "@/client"

export function useTopicMerge() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: TopicMergeRequest) =>
      ContentService.mergeTopics({ requestBody: payload }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["admin-topics"] })
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === "topic-questions" &&
          query.queryKey[1] === variables.destination_topic_id,
      })
    },
  })
}
